import { Component, computed, inject } from '@angular/core';
import { EmbedLayoutStore } from "./embed-layout.store";
import { isAllowed } from "../../shared/shared.global-service";
import { OrganizationYearSelectComponent } from "../components/organization-year-select/organization-year-select.component";
import { Location } from "@angular/common";

@Component({
    selector: 'app-embed-layout',
    templateUrl: './embed-layout.component.html',
    providers: [EmbedLayoutStore],
    imports: [
		OrganizationYearSelectComponent,
	],
})
export class EmbedLayoutComponent {
    public readonly store = inject(EmbedLayoutStore);
    private location = inject(Location);


  	protected readonly isAllowed = isAllowed;

	protected renderFiscalYearComponent = computed(() => 
		(isAllowed['madoAccount.read']() || 
		isAllowed['madoAccount.create']() || 
		isAllowed['madoAccount.update']() ||
		isAllowed['madoAccount.delete']()) && this.location.path()?.startsWith('/embed/accounting'),
	);
}
